'use client'

import { RefObject, useEffect, useRef } from 'react'
import { omit } from '@nwwp/utils'
import { useIsElementInViewport } from './use-is-element-in-viewport'
import { useSegmentAnalytics } from '../components/Provider'

type Props = {
  element: string
} & Record<string, unknown>

export const useTrackElementImpression = (elementRef: RefObject<HTMLElement | null>, params: Props) => {
  const analytics = useSegmentAnalytics()
  const impressionEmitted = useRef(false)
  const isElementInViewport = useIsElementInViewport(elementRef, {
    threshold: 0,
  })

  useEffect(() => {
    if (isElementInViewport && !impressionEmitted.current) {
      impressionEmitted.current = true

      analytics.track('Element Impression', {
        ...omit(params, ['element']),
        element: params.element,
      })
    }
  }, [analytics, isElementInViewport, elementRef])
}
